import React, { useState } from "react";
import { Box, Switch, Tab, Tabs } from "@material-ui/core";
import AllCalibrationPage from "./calibrations-all/calibrations-all-page";
import AveragedCalibrationsPage from "./averaged-calibrations/averaged-calibrations-page";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TabPanel from "./utils/TabPanel";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function CalibrationsPage() {
  const [value, setValue] = useState(0);
  const [isDetailedData, setIsDetailedData] = useState(false);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Box>
          <FormControlLabel
            label="Zaawansowane dane"
            control={
              <Switch
                checked={isDetailedData}
                onChange={() => setIsDetailedData((prevState) => !prevState)}
                name="details"
                color="primary"
              />
            }
          />
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="zakładki kalibracji"
          >
            <Tab label="Wszystkie Kalibracje" {...a11yProps(0)} />
            <Tab label="Uśrednione Kalibracje" {...a11yProps(1)} />
          </Tabs>
        </Box>
      </Box>
      <TabPanel value={value} index={0}>
        <AllCalibrationPage isDetailedData={isDetailedData} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <AveragedCalibrationsPage isDetailedData={isDetailedData} />
      </TabPanel>
    </Box>
  );
}
